// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"296":"ea88be26","7538":"recorder","9983":"profiler"}[chunkId] + "." + {"296":"6fc2bdc0617142ae","7538":"6a896f39edb60628","9983":"d313e32a1eef4bad"}[chunkId] + ".js";
};